import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "Redux/Actions/actionTypes";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";
import AccountSearchRequest from "../../Communication/ApiClasses/AccountSearchRequest";

// worker
function* handleAccountSearch(action) {
  yield put(doLoadingStart(actionTypes.ACCOUNT_SEARCH));

  const accountSearchRequest = new AccountSearchRequest(action.data);
  try {
    const result = yield call(accountSearchRequest.getData);
    yield put({
      type: `${actionTypes.ACCOUNT_SEARCH}_SUCCESS`,
      response: result.data,
    });
    yield call(action.callback, result);
  } catch (error) {
    yield put({
      type: `${actionTypes.ACCOUNT_SEARCH}_ERROR`,
      error,
    });
    yield call(action.callback, { error });
  } finally {
    yield put(doLoadingFinish(actionTypes.ACCOUNT_SEARCH));
  }
}

// watcher
export default function* accountSearchSaga() {
  yield takeLatest(actionTypes.ACCOUNT_SEARCH, handleAccountSearch);
}
